<template>

  <div>
    <div>
       <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="试卷名称">
              <a-input placeholder="请输入" v-model="where.keyword.testpaperName" />
            </a-form-item>
          </a-col>
         
          <a-col :span="16" :style="{ textAlign: 'left' }">
            <a-button type="primary" @click="searchList">搜索</a-button>
          </a-col>
        </a-row>
      </a-form>
      <pxkeji-btn name="添加" class="pxkeji_basic_btn" @click="showInfo('0')" type="primary" />

      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :locale="{emptyText:'暂无数据'}"
      >
        <span slot="status" slot-scope="status">
          <a-tag v-if="status==0" color="gray">未发布</a-tag>
          <a-tag v-else-if="status==1" color="green">进行中</a-tag>
          <a-tag v-else color="red">已结束</a-tag>
        </span>
        <span slot="action" slot-scope="info">
          <pxkeji-btn name="编辑" :roles="[]" size="small" @click="showInfo(info.id)" type="primary" />
          <a-divider type="vertical" />
          <pxkeji-btn name="删除" :roles="[]" size="small" @click="delInfo(info.id)"  type="default" class="pxkeji_dro_btn" />
        </span>
      </a-table>
      <div class="totalbox" style="float: left;">
        <div>
          <span>共有：{{list.pagination.total}}条数据</span>
        </div>
      </div>
    </div>

    <a-modal
      title="新建"
      v-model="info.visible"
      width="50%"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <Info @callbackMethod="save" :examinationId="info.examinationId" :id="info.id" :limit="limit" />
    </a-modal>
  </div>
  
</template>
<script>
import Info from "./papersInfo.vue"; //添加考试

const columns = [
  // {
  //   dataIndex: "id",
  //   key: "id",
  //   align: "center",
  //   title: "序号"
  // },
  {
    dataIndex: "testpaperName",
    key: "testpaperName",
    align: "center",
    title: "试卷名称",
  },
  // {
  //   dataIndex: "questionsCount",
  //   key: "questionsCount",
  //   align: "center",
  //   title: "题目数量"
  // },
  // {
  //   dataIndex: "passLine",
  //   key: "passLine",
  //   align: "center",
  //   title: "及格分数线"
  // },
  // {
  //   dataIndex: "addUser",
  //   key: "addUser",
  //   align: "center",
  //   title: "添加人"
  // },
  // {
  //   dataIndex: "examPeople",
  //   key: "examPeople",
  //   align: "center",
  //   title: "考试人数"
  // },
  // {
  //   dataIndex: "aboutCourse",
  //   key: "aboutCourse",
  //   align: "center",
  //   title: "关联课程"
  // },
  // {
  //   dataIndex: "examStatus",
  //   key: "examStatus",
  //   align: "center",
  //   title: "状态",
  //   scopedSlots: { customRender: "status" }
  // },
  {
    title: "操作",
    key: "action",
    width: 200,
    align: "center",
    scopedSlots: { customRender: "action" }
  }
];

var that;
export default {
  name: "storelist",
   props: {
    examinationId: String,
    limit:Number
  },
  data() {
    return {
      treeData: [],
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
           showTotal: function(total, range) {
            return "共 "+total+" 条";
          },
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          testpaperName: "",
        }
      },
      selectRows: [], //选中项编号
      isloading: false,
      info: {
        title: "",
        visible: false,
        id: 0,
        parentid: 0
      }
    };
  },
  components: {
    Info
  },
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      console.log("examinationId",this.examinationId);
      this.GetList();
      // this.getTree();
    });
  },
  watch: {
    selectRows: function() {
      //console.log("watch", val);
    }
  },
  methods: {
    toggle() {
      this.expand = !this.expand;
    },
    GetList() {
      //获取列表
      this.isloading = true;
      this.clearRows();
      this.$api.testPaper
        .getByExamination(
          this.list.pagination.current,
          this.list.pagination.defaultPageSize,
          this.where.keyword.testpaperName,
          this.examinationId
        )
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
          } else {
            this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    treeChange(val) {
      this.where.keyword.categoryId = val;
    },
    getTree() {
      this.$api.cms.articlecategory
        .getTree()
        .then(res => {
          if (res.errorCode == this.$msg.responseCode.success) {
            this.treeData = res.data;
            res.data.unshift({ label: "根目录", parentid: 0, value: 0 });
            this.where.keyword.categoryId = [res.data[0].value];
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      //table 多选
      this.selectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    //日期选择
    timeonChange(date, dateString) {
      this.where.keyword.startDate = dateString[0];
      this.where.keyword.endDate = dateString[1];
    },
    //查看订单
    showInfo(id) {
      this.info.title = id ? "编辑" : "添加";
      this.info.visible = true;
      this.info.id = id;
      this.info.examinationId=this.examinationId;
    },
    //子组件传值
    save() {
      this.info.visible = false;
      this.GetList();
    },
    close() {
      this.$confirm({
        title: "提示",
        content: "您确定要禁用么",
        okText: "确认",
        cancelText: "取消"
      });
    },
    delInfo(id) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          // console.log("OK", id);
          that.isloading = true;
          that.$api.testPaper
            .removeById(id)
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {
          //console.log("Cancel");
        }
      });
    },
    /** 批量删除 */
    batchDelete() {
      this.$confirm({
        title: "您确定要执行批量删除的操作吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.testPaper
            .deleteByIds(that.selectRows.join(","))
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {}
      });
    },
    quitInfo(id) {}
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}

.cang_sta {
  text-align: center;
}

.cang_sta img {
  width: 35px;
}
</style>

